<template>
  <div class="company-detail-page page-content" v-if="company">
    <el-row class="page-header -with-back-button" type="flex" justify="space-between">
      <el-col :span="24">
        <h2 class="page-title">รายละเอียดบริษัท</h2>
      </el-col>
    </el-row>
    <div class="company-detail-info">
      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">รายละเอียดบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              ชื่อบริษัท
            </el-col>
            <!--<el-col :span="12" class="label">
              Bill payment card name
            </el-col>-->
          </el-row>
          <el-row>
            <el-col :span="12">{{ company.name }}</el-col>
            <!--<el-col :span="12">{{ company.name_on_payment_card }}</el-col>-->
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              เลขประจำตัวผู้เสียภาษี
            </el-col>
            <el-col :span="12" class="label">
              เว็ปไซต์สำหรับจัดการของบริษัท
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ taxIdFormatter(company.tax_id) }}</el-col>
            <el-col :span="12">
              <code class="slug-host-code">{{ `${baseHost}/${company.slug}` }}</code>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="24" class="label">
              โลโก้บริษัท
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <img class="company-logo-preview" v-if="company.logo" :src="company.logo" :alt="company.name" />
            </el-col>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="detail-section">
        <el-row>
          <el-col :span="24">
            <h3 class="section-title">ที่อยู่หลักของบริษัท</h3>
          </el-col>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="24" class="label">
              ที่อยู่
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">{{ company.address.line_1 }}</el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              อำเภอ/เขต
            </el-col>
            <el-col :span="12" class="label">
              ตำบล/แขวง
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ company.address.city }}</el-col>
            <el-col :span="12">{{ company.address.district }}</el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              จังหวัด
            </el-col>
            <el-col :span="12" class="label">
              รหัสไปรษณีย์
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ company.address.province }}</el-col>
            <el-col :span="12">{{ company.address.postal_code }}</el-col>
          </el-row>
        </el-row>
        <el-row class="detail-row">
          <el-row>
            <el-col :span="12" class="label">
              โทรศัพท์
            </el-col>
            <el-col :span="12" class="label">
              โทรสาร
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">{{ telFormatter(company.address.tel) }}</el-col>
            <el-col :span="12">{{ faxFormatter(company.address.fax) }}</el-col>
          </el-row>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
import { createMask } from 'imask';
import helpers from '@/libs/helpers';
/**
 * Company List view
 */
const CompanyDetailView = {
  name: 'company-detail',
  props: ['companyId'],
  data() {
    return {
      isSubmitting: false,
      mask: {
        taxId: {
          mask: [
            { mask: '0000000000' },
            { mask: '0000000000000' },
          ],
        },
        tel: {
          mask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
            { mask: '{0}00-000-0000' },
          ],
        },
        fax: {
          mask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
          ],
        },
      },
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company() {
      return this.$store.getters.currentCompany;
    },
    baseHost() {
      return helpers.getCurrentBaseHost();
      // return window.appConfig.BASE_HOST;
    },
  },
  methods: {
    backToCompanyList() {
      this.$router.push({ name: 'CompanyList' });
    },
    telFormatter(val) {
      if (val) {
        // return this.maskFormatter(val, this.mask.tel);
        return val;
      }
      return '-';
    },
    faxFormatter(val) {
      if (val) {
        // return this.maskFormatter(val, this.mask.fax);
        return val;
      }
      return '-';
    },
    taxIdFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.taxId);
      }
      return '-';
    },
    maskFormatter(val, maskOptions) {
      const mask = createMask(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },
  },
  mounted() {
    if (typeof this.companyId === 'undefined') {
      // redirect back
      this.backToCompanyList();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId));
  },
};
export default CompanyDetailView;
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/company/company-detail.vue